import { render, staticRenderFns } from "./FormChangePassword.vue?vue&type=template&id=707c6099&scoped=true&"
import script from "./FormChangePassword.vue?vue&type=script&lang=js&"
export * from "./FormChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./FormChangePassword.vue?vue&type=style&index=0&id=707c6099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c6099",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInputPassword: require('/workspace/components/Form/FormInputPassword.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default})
